import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import { ReduxState } from "../../../../redux";
import EmptyState from "../../../Docuclipper/EmptyState/EmptyState";

type Props = {};
export const FieldsNoData: React.SFC<Props> = () => {
  const { canvasMode, job, page } = useSelector(
    (state: ReduxState) => state.TemplateField
  );
  if (page.loading || job.loading) {
    return <ClipLoader loading={true} />;
  }
  if (canvasMode === "viewExtractedData") {
    return <Alert variant="danger">This page doesn't have any data</Alert>;
  }

  return (
    <div className="my-2">
      <EmptyState
        title=""
        renderDescription={() => (
          <p>
            Click and drag to draw a box around the data you want to extract
          </p>
        )}
        renderLinks={() => [
          // <a
          //   href="/docs/ui/user-guide/extracting-data/from-custom-documents/"
          //   target="_blank"
          // >
          //   <FontAwesomeIcon icon="external-link-alt" />
          //   <span className="ml-1">
          //     Read the documentation for creating templates
          //   </span>
          // </a>,
        ]}
        renderMainBtn={() => <></>}
        renderSecondaryBtn={() => (
          // <VideoModal btnText="Watch a tutorial" youtubeId="difGDb_eeuk" />

          <a
            href="https://www.youtube.com/watch?v=yQvvGdDuE3k&authuser=0"
            target="_blnk"
            rel="noopener noreferrer"
          >
            <div className="ml-2 div--help-video">
              <FontAwesomeIcon icon="play" />
              <span className="ml-2" /*variant="link"*/>Watch tutorial</span>
            </div>
          </a>
        )}
        imgSrc=""
        imgAlt=""
      />
    </div>
  );
};
